import { FormattedMessage } from 'react-intl'
import { Box } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import QuotasStatsBarChart from './QuotasStatsBarChart'
import useIsIndividualUser from 'features/users/state/useIsIndividualUser'
import { useAccountQuotas } from '../hooks'

function UsersQuotaStats() {
  const isIndividualUser = useIsIndividualUser()
  const quotas = useAccountQuotas()

  if (isIndividualUser) return null

  return (
    <Box>
      <Typography variant="subtitle2" color="textSecondary" mb={2}>
        <FormattedMessage id="account.cards.usage.usersTitle" />
      </Typography>
      <QuotasStatsBarChart {...quotas.editors} labelId="editorUsers" />
      <QuotasStatsBarChart {...quotas.viewers} labelId="viewerUsers" />
    </Box>
  )
}

export default UsersQuotaStats
